import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from 'src/app/services/service.service';
import { NgbCustomDateParserService } from 'src/app/formatters/ngb-custom-date-parser.service';
import { DatePipe } from '@angular/common';
import { DRSFilter } from './drs-filter.model';
import { TBLUser } from '../app-modules/dashboard/models/tbluser.model';

@Component({
  selector: 'app-driver-route-sheet',
  templateUrl: './driver-route-sheet.component.html',
  styleUrls: ['./driver-route-sheet.component.css']
})
export class DriverRouteSheetComponent implements OnInit {

    public size: number = 100;
    public page: number = 0;
    public logon: any = "";
    public scac : any = "";
    public drsStartDate : any;
    public drsEndDate : any;
    users: any[] = [];
  
    drsFilter: DRSFilter = new DRSFilter();
  
    hoveredDate: NgbDate;
    selectedRecord: TBLUser;
    selectedItem: any;
    showOverlay = false;
    billOfLadingList: any;
    selectedDevice: any = {};
    @Input() fromBolPage: boolean;
    @Output() selectRoute: EventEmitter<any> = new EventEmitter<any>();

    isScacInvalid: boolean = false;

  constructor(private route: ActivatedRoute,
      private router: Router,
      private service: ServiceService,
      public ngbCustomDateParserService: NgbCustomDateParserService,
      public formatter: NgbDateParserFormatter,
      private calendar: NgbCalendar,
      private ngModal: NgbModal,
      private datePipe: DatePipe,) { 

        this.drsFilter.fromDate = calendar.getPrev(calendar.getToday(), 'd', 2);
        this.drsFilter.toDate = calendar.getNext(calendar.getToday(), 'd', 1);

      }

  ngOnInit(): void {
  }

  submitMethod(){
    if (!this.drsFilter.scac) {
      this.validateScac();
    }else{
    $(".overlay-loading").show();
    this.drsFilter.drsStartDate = new Date(this.drsFilter.fromDate.year, this.drsFilter.fromDate.month - 1, this.drsFilter.fromDate.day) + "";
    this.drsFilter.drsEndDate = new Date(this.drsFilter.toDate.year, this.drsFilter.toDate.month - 1, this.drsFilter.toDate.day) + "";
    this.drsFilter.drsStartDate = this.datePipe.transform(this.drsFilter.drsStartDate, 'yyyy-MM-dd');
    this.drsFilter.drsEndDate = this.datePipe.transform(this.drsFilter.drsEndDate, 'yyyy-MM-dd');
    
    this.service.getDriverRouteSheetDetails(this.drsFilter, this.page, this.size).subscribe(res => {
      
      $(".overlay-loading").hide();
      this.users = res;
    }, error => {
      $(".overlay-loading").hide();
      console.log(error);
    });
  }
}

nextBtnClick(incr) {
  this.page = +this.page + incr;
  this.submitMethod();
}

formatDateForDisplay(date) {
  return this.ngbCustomDateParserService.format(date);
}

closeDatePicker = false;
onDateSelection(date: NgbDate) {
  this.closeDatePicker = false;
  if (!this.drsFilter.fromDate && !this.drsFilter.toDate) {
    this.drsFilter.fromDate = date;
  } else if (this.drsFilter.fromDate && !this.drsFilter.toDate && date.after(this.drsFilter.fromDate)) {
    this.drsFilter.toDate = date;
    this.closeDatePicker = true;
    this.showOverlay = false;
  } else {
    this.drsFilter.toDate = null;
    this.drsFilter.fromDate = date;
  }
}

isHovered(date: NgbDate) {
  return this.drsFilter.fromDate && !this.drsFilter.toDate && this.hoveredDate && date.after(this.drsFilter.fromDate) && date.before(this.hoveredDate);
}

isInside(date: NgbDate) {
  return date.after(this.drsFilter.fromDate) && date.before(this.drsFilter.toDate);
}

isRange(date: NgbDate) {
  return date.equals(this.drsFilter.fromDate) || date.equals(this.drsFilter.toDate) || this.isInside(date) || this.isHovered(date);
}

validateInput(currentValue: NgbDate, input: string): NgbDate {
  const parsed = this.formatter.parse(input);
  return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
}

public redirectToEditScreen(selectedLoad?: any): void {
  localStorage.setItem('selectedLoad', JSON.stringify(selectedLoad));
  this.router.navigate(['load-details/add-edit/loadDetails/true'], {state: {load:selectedLoad}});
}

public redirectToDriverScreen(selectedLoad?: any): void {
  this.service.getTblUsersByLogon(selectedLoad?.driverDTO?.logon, selectedLoad?.scac).subscribe(res => {
    this.selectedRecord = res;
    $(".overlay-loading").hide();
  }, error => {
    $(".overlay-loading").hide();
    console.log(error);
  });

}

public redirectToBolScreen(selectedLoad?: any): void {
  

  if(this.fromBolPage){
    let scacRoute = {
      scac: this.drsFilter?.scac,
      selectedRoute: selectedLoad
    }
    this.selectRoute.emit(scacRoute);
  } else {
    
    this.service.getBolFromDrsDetails(selectedLoad?.routeId, selectedLoad?.scac, this.page, this.size).subscribe(res => {
      $(".overlay-loading").hide();
      this.billOfLadingList = res.map(bol => ({ ...bol, showDetails: false }));
    }, error => {
      $(".overlay-loading").hide();
      console.log(error);
    });
  }
}

getCommaSeparatedValues(items: any[], key: string): string {
  // remove all the duplicate values from the array
  items = items.filter((item, index, self) =>
    index === self.findIndex((t) => (
      t[key] === item[key]
    ))
  );
  return items.map(item => item[key]).join(', ');
}

openDeviceModal(device: any): void {
  this.selectedDevice = device;
}

validateScac() {
  this.isScacInvalid = !this.drsFilter.scac.trim(); 
}


}
